/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_AntragstellerInputs */

const de__field_antragsteller = /** @type {(inputs: _Field_AntragstellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antragsteller`)
};

/**

* @param {_Field_AntragstellerInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_antragsteller = /** @type {((inputs?: _Field_AntragstellerInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_AntragstellerInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_antragsteller(inputs)
});